/**
 * SIL-473 — Circularity tab number formatting. The Overview tab's
 * `formatTonnes` (`environmental/format.ts`) rounds to whole tonnes, which
 * is right for footprint-scale KPI tiles but would silently round away
 * this tab's adder-scale figures (a single gpu's Cat-5 disposal burden is
 * ~0.05 kgCO2e per the SIL-420 defaults table — `Math.round(x / 1000)`
 * reads "0 t" for every such number). This formatter shows kg below 1,000
 * and switches to tonnes above it, so a genuinely small real number stays
 * visible rather than disappearing.
 */
export function formatCarbonMass(kgco2e: number | null | undefined): string {
  if (kgco2e === null || kgco2e === undefined || Number.isNaN(kgco2e)) return '—';
  const abs = Math.abs(kgco2e);
  if (abs < 1000) {
    const maximumFractionDigits = abs === 0 ? 0 : abs < 1 ? 3 : abs < 10 ? 2 : 1;
    return `${kgco2e.toLocaleString('en-US', { maximumFractionDigits })} kgCO2e`;
  }
  const tonnes = kgco2e / 1000;
  const maximumFractionDigits = Math.abs(tonnes) < 100 ? 1 : 0;
  return `${tonnes.toLocaleString('en-US', { maximumFractionDigits })} tCO2e`;
}
